import { combineReducers } from 'redux';

import isFetching from './isFetching';
import isVisible from './isVisible';

/** @typedef {{ isFetching: boolean, isVisible: boolean }} AuditModelUIModalDuplicateReducer */

export default combineReducers({
  isFetching,
  isVisible,
});
